import { render, staticRenderFns } from "./VisitName.vue?vue&type=template&id=47c4ee2d&scoped=true&"
import script from "./VisitName.vue?vue&type=script&lang=js&"
export * from "./VisitName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4ee2d",
  null
  
)

export default component.exports